import React, { useEffect, useMemo, useState } from "react";
import { Link, useParams } from "react-router-dom";
import api from "../../api/client";

export default function InfraServiceDetailsPage({ user }) {
  const { systemId, gid } = useParams();
  const [hostData, setHostData] = useState(null);
  const [loading, setLoading] = useState(true);

  const decodedGid = decodeURIComponent(gid || "");
  const shortName = useMemo(() => {
    const idx = decodedGid.indexOf(":");
    return idx > -1 ? decodedGid.slice(idx + 1) : decodedGid;
  }, [decodedGid]);

  useEffect(() => {
    let ok = true;
    (async () => {
      try {
        setLoading(true);
        const { data } = await api.get(`/collector/hosts/${encodeURIComponent(systemId)}`);
        if (ok) setHostData(data);
      } catch (e) {
        console.error(e);
        if (ok) setHostData(null);
      } finally {
        if (ok) setLoading(false);
      }
    })();
    return () => { ok = false; };
  }, [systemId]);

  const svc = useMemo(() => {
    const arr = Array.isArray(hostData?.services) ? hostData.services : [];
    return arr.find(s => (s.gid || s.id) === decodedGid)
        || arr.find(s => s.service === shortName)
        || null;
  }, [hostData, decodedGid, shortName]);

  return (
    <div style={{ padding: 24 }}>
      {loading ? (
        <p>Loading…</p>
      ) : !hostData ? (
        <p>Host not found.</p>
      ) : !svc ? (
        <>
          <p>Service not found.</p>
          <Link to={`/infra/hosts/${encodeURIComponent(systemId)}`}>← Back to host</Link>
        </>
      ) : (
        <>
          <h1 style={{ marginBottom: 4 }}>{svc.service}</h1>
          <div style={{ color:"#666", marginBottom: 10 }}>
            Host: <Link to={`/infra/hosts/${encodeURIComponent(systemId)}`}>{hostData.host || systemId}</Link>
            {" · "}
            GID: <code>{svc.gid || "(none)"}</code>
          </div>

          <div style={{ display:"grid", gap: 10, gridTemplateColumns:"repeat(auto-fit, minmax(260px, 1fr))" }}>
            <div style={{ border:"1px solid #ddd", borderRadius:8, padding:12 }}>
              <h3>Overview</h3>
              <div>Status: <strong>{svc.healthy ? "Healthy" : "Issue"}</strong></div>
              <div>Active: {svc.active}</div>
              <div>Platform: {svc.platform}</div>
              <div>Load: {svc.load}</div>
              <div>Sub: {svc.sub}</div>
              {svc.unitFileState && <div>UnitFileState: {svc.unitFileState}</div>}
              {svc.path && <div>Path: <code>{svc.path}</code></div>}
              <div>Updated: {svc.updatedAt ? new Date(svc.updatedAt).toLocaleString() : "—"}</div>
            </div>

            <div style={{ border:"1px solid #ddd", borderRadius:8, padding:12 }}>
              <h3>Description</h3>
              <p style={{ whiteSpace:"pre-wrap" }}>{svc.description || "—"}</p>
            </div>
          </div>

          <div style={{ marginTop: 20 }}>
            <Link to={`/infra/hosts/${encodeURIComponent(systemId)}`}>← Back to host</Link>
          </div>
        </>
      )}
    </div>
  );
}
